import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DngrEvalDetail from '../components/danger-evaluation/DngrEvalDetail';
import DngrEvalList from '../components/danger-evaluation/DngrEvalList';
import NavbarText from '../components/NavbarText';
import * as securityHelper from "../helper/SecurityHelper";

export default function DngrEval() {
  const navigate = useNavigate();
  const user = securityHelper.getLoginUser();
  const [tab, setTab] = useState('list');
  const [wrkDclrSeq, setWrkDclrSeq] = useState();

  const backEvent = () => {
    if (tab === 'list') { navigate(-1) }
    else { setTab('list') };
  }

  return (
    <div className='w-screen h-[calc(100dvh)] relative'>
      <NavbarText backEvent={backEvent}>위험성 평가서</NavbarText>
      {tab === 'list'
        ? <DngrEvalList auth={user.auth} setTab={setTab} setWrkDclrSeq={setWrkDclrSeq} />
        : <DngrEvalDetail wrkDclrSeq={wrkDclrSeq} setTab={setTab} />}
    </div>
  );
}

